import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { Grid, Button, Glyphicon, Well, Tab, Tabs } from 'react-bootstrap'
import axios from 'axios'
import swal from 'sweetalert'

import { getMetadata } from '../projects/reducers/manageProjects'

import { handleErrorFetchingData } from '../../functions/errorHandling'
import getServerURL from '../../functions/getServerURL'

import AuthenticationComponent from '../../AuthenticationComponent'

import ProjectOverview from './components/ProjectOverview'

import Updates from '../../reuseable-components/updates/Updates'
import Documentation from '../../reuseable-components/documentation/Documentation'
import Deliverables from '../../reuseable-components/deliverables/Deliverables'

import './style.css'

class ProjectPageContainer extends Component {

  state = {
    key: this.props.type,
    project: null,
    fetchingCurrentProject: false,
  }

  componentDidMount() {
    this.setState({ key: this.props.type })
    let { projectId } = this.props

    if (!projectId) {
      projectId = this.props.match.params.project
    }

    this.getCurrentProject(projectId)
    this.props.getMetadata()
  }


  getCurrentProject = (projectId) => {
    this.setState({ fetchingCurrentProject: true })
    axios(`${getServerURL()}projects/${projectId}/`,{
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("token")
      },
    })
    .then(response => {
      return this.setState({ project: response.data, fetchingCurrentProject: false })
    })
    .catch(error => {
      if (error.response.status === 404) {
        return this.setState({ project: null, fetchingCurrentProject: false })
      } else {
        const message = 'There was an error fetching the project'
        handleErrorFetchingData(error, message)
      }
    })
  }


  editProject = (key, value, url) => {

    let updatedValue = value

    if (updatedValue && Array.isArray(updatedValue)) {
      updatedValue = updatedValue.map(item => item.url)
    }

    swal({
      text: "Editing the project... Please stand by.",
      icon: require("../../static/images/spinner.gif"),
      button: false
    })
    axios({
      method: "PATCH",
      url: url,
      data: {[key]: updatedValue},
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      swal({
        title: "Success",
        text: `Project has been updated`,
        icon: "success",
        button: "Continue",
      })
      const project = { ...this.state.project, [key]: value }
      return this.setState({ project })
    })
    .catch(error => {
      const message = "There was an error editing your project"
      return handleErrorFetchingData(error, message)
    })
  }


  addProjectDeliverable = (newDeliverable) => {
    const { project } = this.state
    return this.setState({
      project: { ...project, deliverables: [...project.deliverables, newDeliverable] }
    })
  }


  editDeliverable = (updatedDeliverable) => {
    const { project } = this.state
    const deliverableIndex = project.deliverables.findIndex(deliverable => {
      return deliverable.id === updatedDeliverable.id
    })

    let deliverables = [
      ...project.deliverables.slice(0, deliverableIndex),
      updatedDeliverable,
      ...project.deliverables.slice(deliverableIndex + 1),
    ]

    return this.setState({ project: {...project, deliverables } })
  }


  deleteDeliverable = (deliverableId) => {
    const { project } = this.state

    const deliverables = project.deliverables.filter(deliverable => deliverable.id !== deliverableId)

    return this.setState({ project: {...project, deliverables } })
  }


  addDeliverableDocument = (deliverableUrl, deliverableDocument) => {
    const { project } = this.state

    let deliverableIndex = project.deliverables.findIndex(deliverable =>  deliverable.url === deliverableUrl)

    let deliverable = project.deliverables[deliverableIndex]

    let deliverableDocuments

    if (Array.isArray(deliverableDocument)) {
      deliverableDocuments = [...deliverable.documents, ...deliverableDocument]
    } else {
      deliverableDocuments = [...deliverable.documents, deliverableDocument]
    }

    deliverable = {...deliverable, documents: deliverableDocuments}

    let deliverables = [...project.deliverables.slice(0, deliverableIndex), deliverable, ...project.deliverables.slice(deliverableIndex + 1)]

    return this.setState({ project: {...project, deliverables } })
  }


  deleteDeliverableDocument = (documentUrl, deliverableUrl) => {
    const { project } = this.state
    let deliverableIndex = project.deliverables.findIndex(deliverable =>  deliverable.url === deliverableUrl)

    let deliverable = project.deliverables[deliverableIndex]

    let deliverableDocuments = deliverable.documents.filter(doc => doc.url !== documentUrl)

    deliverable = {...deliverable, documents: deliverableDocuments}

    let deliverables = [...project.deliverables.slice(0, deliverableIndex), deliverable, ...project.deliverables.slice(deliverableIndex + 1)]

    return this.setState({ project: { ...project, deliverables } })
  }


  addProjectUpdate = (newUpdate) => {
    const { project } = this.state
    const updates = [...project.updates, newUpdate]
    return this.setState({ project: { ...project, updates } })
  }


  deleteProjectUpdate = (updateUrl) => {
    const { project } = this.state
    const updates = project.updates.filter(update => update.url !== updateUrl)
    return this.setState({ project: { ...project, updates } })
  }


  editProjectUpdate = (editedUpdate) => {
    const { project } = this.state
    let updates = project.updates.filter(update => update.id !== editedUpdate.id)
    updates = [...updates, editedUpdate]
    return this.setState({ project: {...project, updates } })
  }


  addUploadedDocument = (uploadedDocument) => {
    const { project } = this.state
    const documents = [...project.documents, uploadedDocument]
    return this.setState({ project: { ...project, documents } })
  }


  deleteUploadedDocument = (documentUrl) => {
    swal({
      text: "Deleting file... Please stand by.",
      icon: require("../../static/images/spinner.gif"),
      button: false,
      closeOnClickOutside: false,
    })
    axios({
      method:"DELETE",
      url: documentUrl,
      headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
    })
    .then(response => {
      swal({
        title: "Success",
        text: "The file has been deleted",
        icon: "success",
        button: "Continue",
      })

      const { project } = this.state

      const documents = [...project.documents].filter(doc => {
        return doc.url !== documentUrl
      })
      return this.setState({ project: { ...project, documents } })

    })
    .catch(error => {
      const message = "There was an error deleting the file"
      return handleErrorFetchingData(error, message)
    })
  }


  editUploadedDocument = (editedDocument) => {
    const { project } = this.state

    let documents = [...project.documents].filter(doc => doc.url !== editedDocument.url)

    documents = [...documents, editedDocument]

    return this.setState({ project: { ...project, documents } })
  }


  handleSelect = (key) => {
    this.setState({ key })
    if (!this.props.modalView) {
      window.history.pushState(null, null, `/projects/${this.props.match.params.project}/${key}`)
    }
  }


  render () {
    let { metadata, fetchingMetadata } = this.props

    const { project, fetchingCurrentProject } = this.state

    let filteredMetadata = []

    if (project && project.client) {
      filteredMetadata = metadata.filter(meta => meta.client === project.client)
    }

    return (
      <div id="ProjectPageContainer">
        <AuthenticationComponent />
        {project && fetchingCurrentProject === false ?
          <Grid>
          <div>
            <center>
              {this.props.modalView ?
                null
                :
                <div style={{float:"left"}}>
                  <Link to="/projects">
                    <Button className="back-button">
                      <Glyphicon glyph="arrow-left" /> Back
                      </Button>
                    </Link>
                  </div>
              }
              <h4 style={{display:"inline-block"}}>
                {project.short_id}-{project.number} / {project.title}
              </h4>
            </center>
            <Tabs
              id="ProjectPageContainerTabs"
              activeKey={this.state.key}
              onSelect={this.handleSelect}
            >
              <Tab eventKey="project-overview" title="Overview">
                <Well>
                  <ProjectOverview
                    project={project}
                    metadata={filteredMetadata}
                    editProject={this.editProject}
                  />
                </Well>
              </Tab>
              <Tab eventKey="deliverables" title="Deliverables">
                <Well>
                  <Deliverables
                    parentElement={project}
                    parentElementName="project"
                    route="project-deliverables"
                    documentRoute="deliverable-documents"
                    userOptions={[...project.analysts, ...project.project_leads]}
                    addDeliverable={this.addProjectDeliverable}
                    editDeliverable={this.editDeliverable}
                    deleteDeliverable={this.deleteDeliverable}
                    addDeliverableDocument={this.addDeliverableDocument}
                    deleteDeliverableDocument={this.deleteDeliverableDocument}
                  />
                </Well>
              </Tab>
              <Tab eventKey="updates" title="Updates">
                <Well>
                  <Updates
                    parentElement={project}
                    parentElementName="project"
                    route="updates"
                    addUpdate={this.addProjectUpdate}
                    deleteUpdate={this.deleteProjectUpdate}
                    editUpdate={this.editProjectUpdate}
                  />
                </Well>
              </Tab>
              <Tab eventKey="documentation" title="Documentation">
                <Well style={{overflowX: 'scroll'}}>
                  <Documentation
                    parentElement={project}
                    parentElementName="project"
                    route="project-documents"
                    addUploadedDocument={this.addUploadedDocument}
                    editUploadedDocument={this.editUploadedDocument}
                    deleteUploadedDocument={this.deleteUploadedDocument}
                  />
                </Well>
              </Tab>
            </Tabs>
          </div>
          </Grid>
          :
          fetchingCurrentProject || fetchingMetadata ?
          <center>
            <h4> Loading... </h4>
            <img alt="loader" src={require("../../static/images/spinner.gif")} />
          </center>
          :
          <center>
            <h4> Project does not exist </h4>
          </center>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    metadata: state.manageProjects.metadata,
    fetchingMetadata: state.manageProjects.fetchingMetadata,
  }
}

export default withRouter(connect(mapStateToProps, { getMetadata })(ProjectPageContainer))



// WEBPACK FOOTER //
// ./src/routes/projects_project/ProjectPageContainer.js